export const PASSWORD_FORGET_DONE = 'PASSWORD_FORGET_DONE';
export const DUMMY_MUTATION = 'DUMMY_MUTATION';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const LOADING_MESSAGE = '请稍等...';
